<template lang="pug">
.ColorSettings
  .ColorSettings-header.ColorHeader
    .ColorHeader-text
      | Настройки связанных окрасок слоев
    .ColorHeader-close
      button.Btn.BtnIcon(@click='cancel')
        i.Icon.IconClose
  .ColorSettings-main
    .ColorSettings-group.ColorGroup(v-for='coloringConnection in layerColoringConnectionsArray')
      .ColorGroup-header.ColorGroupHeader(@click='toggleColorGroup(coloringConnection)')
        .ColorGroupHeader-text
          span {{ colorings[coloringConnection.coloringId].name }}
        .ColorGroupHeader-layers
          i.Icon.IconLayers
          | {{ Object.keys(coloringConnection.connections).length }}
      .ColorGroup-list(v-if='coloringConnection.coloringId === openedColoringId')
        .ColorGroup-item.ColorItem(v-for='(connected, layerId) in coloringConnection.connections')
          .ColorItem-layer
            | {{ coloringLayerNames[layerId] }}
          .ColorItem-connection
            button.Btn.BtnIcon.BtnIcon--oval(
              :class='{ "Btn--blue": connected, "Btn--greyLighter": !connected }',
              @click='toggleConnection(coloringConnection.coloringId, layerId)'
            )
              i.Icon.IconLinked(v-if='connected')
              i.Icon.IconUnlinked(v-else)
  .ColorSettings-footer
    button.Btn.Btn--blue(@click='save') Сохранить
    button.Btn.Btn--cancel(@click='cancel') Отмена
</template>

<script>
import merge from 'lodash.merge'

export default {
  name: 'color-settings',

  data() {
    return {
      layerColoringConnections: {},
      openedColoringId: null
    }
  },

  computed: {
    coloringLayerNames() {
      return this.$store.getters.coloringLayerNames
    },

    colorings() {
      return this.$store.getters.colorings
    },

    layerColorings() {
      return this.$store.getters.layerColorings
    },

    layerColoringConnectionsArray() {
      return Object.entries(this.layerColoringConnections).map(([coloringId, connections]) => {
        return {
          coloringId,
          connections
        }
      })
    }
  },

  mounted() {
    this.layerColoringConnections = merge({}, this.$store.getters.layerColoringConnections)
  },

  methods: {
    toggleColorGroup(coloringConnection) {
      this.openedColoringId = this.openedColoringId === coloringConnection.coloringId ? null : coloringConnection.coloringId
    },

    toggleConnection(coloringId, layerId) {
      this.layerColoringConnections[coloringId][layerId] = !this.layerColoringConnections[coloringId][layerId]
    },

    save() {
      this.$store.commit('setLayerColoringConnections', {
        layerColoringConnections: this.layerColoringConnections
      })
      this.$ui.popup.ok()
    },

    cancel() {
      this.$ui.popup.ok()
    }
  }
}
</script>
<style lang="scss">
@import '~base';
.Popup .ColorSettings {
  --colorSettingsFooterBorder: #{$grey};
  --colorSettingsClose: #{$grey2};
  --colorSettingsGroupBorder: #{$grey7};
  --colorSettingsGroupBg: #{$grey7};
  --colorSettingsLayers: #{$grey1};
  --colorSettingsBlue: #{$blue};
  --colorSettingsBtnGreyLighterBg: #{$grey6};
  --colorSettingsBtnBg: #{$grey6};
  --colorSettingsBtnColor: #{$black5};
}

.Popup[data-theme='dark'] .ColorSettings {
  --colorSettingsFooterBorder: #{$grey2};
  --colorSettingsClose: #{$grey1};
  --colorSettingsGroupBorder: #{$grey2};
  --colorSettingsGroupBg: #{$grey8};
  --colorSettingsLayers: #{$grey1};
  --colorSettingsBlue: #{$blue};
  --colorSettingsBtnGreyLighterBg: #{$grey3};
  --colorSettingsBtnBg: #{$grey6};
  --colorSettingsBtnColor: #{$black5};
}
</style>
<style scoped lang="scss">
@import '~base';
.ColorSettings {
  color: var(--basicText);

  &-header {
    padding: 30px 35px 0;
  }

  &-main {
    padding: 25px 35px 30px;
  }

  &-footer {
    padding: 5px 35px;
    border-top: 1px solid var(--colorSettingsFooterBorder);

    .Btn {
      margin-right: 10px;
      min-width: 155px;
      text-align: center;
      text-transform: uppercase;
      font-weight: 300;
      font-size: 11px;

      &--cancel {
        color: var(--colorSettingsBtnColor);
        background: var(--colorSettingsBtnBg);
      }
    }
  }
}

.ColorHeader {
  position: relative;

  &-text {
    font-size: 16px;
    font-weight: 500;
    text-transform: uppercase;
  }
  &-close {
    position: absolute;
    top: 7px;
    right: 15px;

    .Btn .Icon {
      color: var(--colorSettingsClose);
      font-size: 14px;
    }
  }
}

.ColorGroup {
  & + & {
    margin-top: 2px;
  }

  &-list {
    margin-bottom: 15px;
    padding: 0 15px;
    border: 1px solid var(--colorSettingsGroupBorder);
  }
}

.ColorGroupHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 15px;
  background: var(--colorSettingsGroupBg);
  cursor: pointer;

  &-text {
    flex: 0 0 auto;

    span {
      padding-bottom: 2px;
      border-bottom: 1px dotted var(--basicText);
      color: var(--basicText);
      font-size: 14px;
      line-height: 16px;
      font-weight: 500;
    }
  }

  &-layers {
    flex: 0 0 50px;
    font-size: 12px;
    color: var(--colorSettingsLayers);

    .Icon {
      font-size: 16px;
      margin-right: 5px;
    }
  }
}

.ColorItem {
  display: flex;
  align-items: center;
  margin: 5px 0;

  &-layer {
    flex: 1 1 auto;
    font-size: 12px;
  }

  &-connection {
    flex: 0 0 50px;
    margin-left: 15px;

    .Btn {
      width: 50px;

      .Icon {
        font-size: 12px;
      }

      &--greyLighter {
        color: var(--colorSettingsBlue);
        background: var(--colorSettingsBtnGreyLighterBg);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/ColorSettings.vue